import React from 'react';

const LEISTUNGEN = [
  'Operations Excellence',
  'Prozessoptimierung',
  'Serviceorganisation',
  'Führungskräfteentwicklung',
];

function Services() {
  return (
    <section id="beratung" className="beratung reveal">
      <div className="beratung__content">
        <h2>Beratung &amp; Workshops</h2>
        <p className="beratung__sub">
          Neben TechSoul unterstütze ich Unternehmen bei ausgewählten Projekten.
        </p>
        <ul className="beratung__list">
          {LEISTUNGEN.map(l => <li key={l}>{l}</li>)}
        </ul>
        <a href="#contact" className="beratung__cta">Anfrage stellen →</a>
      </div>
    </section>
  );
}

export default Services;
